import { useRegisterSW } from "virtual:pwa-register/react";
import { RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      // Stündlich auf Updates prüfen
      if (registration) {
        setInterval(() => registration.update(), 60 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div
      role="dialog"
      aria-label="Update verfügbar"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50
                 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-700
                 rounded-xl shadow-xl p-4 flex items-start gap-3"
    >
      <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center flex-shrink-0">
        <RefreshCw className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm text-zinc-900 dark:text-zinc-100">
          Update verfügbar
        </p>
        <p className="text-xs text-zinc-500 dark:text-zinc-400 mt-0.5">
          Eine neue Version von Icarus D&D ist bereit.
        </p>
        <Button
          size="sm"
          className="mt-2 h-7 text-xs bg-primary hover:bg-primary-hover text-white"
          onClick={() => updateServiceWorker(true)}
        >
          <RefreshCw className="w-3 h-3 mr-1" />
          Jetzt aktualisieren
        </Button>
      </div>
      <button
        onClick={() => setNeedRefresh(false)}
        className="text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-200 flex-shrink-0 mt-0.5"
        aria-label="Später"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
